import { IterableMap, genericMemo } from "@redotech/react-util/component";
import * as classNames from "classnames";
import { ReactNode } from "react";
import * as bubblesCss from "./bubbles.module.css";

export type BubbleState =
  | typeof BubbleState.DISABLED
  | typeof BubbleState.FADED
  | typeof BubbleState.DEFAULT;

export namespace BubbleState {
  export const DISABLED = Symbol("disabled");
  export const FADED = Symbol("faded");
  export const DEFAULT = Symbol("default");
}

const bubbleStateClasses = new Map<BubbleState, string>();
bubbleStateClasses.set(BubbleState.DISABLED, bubblesCss.buttonDisabled);
bubbleStateClasses.set(BubbleState.FADED, bubblesCss.buttonFaded);

export const Bubbles = genericMemo(function Bubbles<T>({
  value,
  options,
  children = (option) => String(option),
  onChange,
  state = () => BubbleState.DEFAULT,
}: {
  value: T;
  onChange(option: T): void;
  children?: (option: T) => ReactNode | ReactNode[];
  options: T[];
  state?: (option: T) => BubbleState;
}) {
  return (
    <div className={bubblesCss.container}>
      <IterableMap items={options} keyFn={(_, index) => index}>
        {(option) => {
          const bubbleState = state(option);
          return (
            <button
              className={classNames(
                bubblesCss.button,
                value === option
                  ? bubblesCss.buttonSelected
                  : bubbleStateClasses.get(bubbleState),
              )}
              disabled={bubbleState === BubbleState.DISABLED}
              onClick={() => {
                if (bubbleState !== BubbleState.DISABLED) {
                  onChange(option);
                }
              }}
              type="button"
            >
              {children(option)}
            </button>
          );
        }}
      </IterableMap>
    </div>
  );
});
